import Loader from '@components/shared/loader/Loader';
import { logoutRedirect } from '@services/auth/AuthService';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';

const LogoutPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutAsync = async (): Promise<void> => {
      try {
        await logoutRedirect();
        navigate('/');
      } catch (error) {
        console.error('Logout error:', error);
      }
    };

    logoutAsync();
  }, []);

  return <Loader />;
};

export default LogoutPage;
